"use client";

import { useEffect } from "react";
import {GA_TRACKING_ID} from "~/lib/gtag";
import {GA_CSR_TRACKING_ID} from "~/lib/gtagCSRDashboard";

const ClientAnalytics = () => {
    useEffect(() => {
        // The deployment's service network id (e.g. DTE) so GA can identify the data per-utility.
        const serviceNetworkId = process.env.NEXT_PUBLIC_SNID;

        const handleRouteChange = (url) => {
            if (url.includes('/cs-dashboard')) {
                window.gtag("config", GA_CSR_TRACKING_ID, {
                    page_path: url,
                    service_network_id: serviceNetworkId,
                });
            } else {
                window.gtag("config", GA_TRACKING_ID, {
                    page_path: url,
                    service_network_id: serviceNetworkId,
                });
            }
        };

        window.addEventListener("popstate", () => handleRouteChange(window.location.pathname));

        return () => {
            window.removeEventListener("popstate", handleRouteChange);
        };
    }, []);

    return null;
};

export default ClientAnalytics;
